import React from 'react';
import { setCurrentView } from 'core/utils';
import DaVinciBusinessPartnersTemplate from 'themes/modules/seller/pages/DaVinciBusinessPartnersTemplate';
import DaVinciBusinessPartnersViewStore from '../stores/DaVinciBusinessPartnersViewStore';

@setCurrentView(
	(rootStore, componentProps) => new DaVinciBusinessPartnersViewStore(rootStore, componentProps),
	'daVinciBusinessPartnersViewStore'
)
class DaVinciBusinessPartners extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <DaVinciBusinessPartnersTemplate {...this.props} viewStore={this.props.daVinciBusinessPartnersViewStore} />;
	}
}

export default DaVinciBusinessPartners;



// WEBPACK FOOTER //
// ./src/modules/seller/pages/DaVinciBusinessPartners.jsx